import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Intro() {
  const leftColRef = useRevealOnScroll();
  const rightColRef = useRevealOnScroll();
  return <section className="relative overflow-hidden bg-background ![padding:80px_0px_60px_0px]">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-12 items-center w-full lg:grid-cols-2 lg:gap-24">
          {}
          <div ref={leftColRef} className="flex flex-col justify-center space-y-8 text-left max-w-2xl w-full px-4 lg:px-6">
            <h2 className="tracking-tighter text-foreground leading-[1.1] text-3xl font-default font-bold !not-italic md:text-4xl lg:text-5xl">Onze aanpak</h2>
            <div className="space-y-6 mt-6 w-full">
              <p className="text-muted-foreground leading-relaxed">
                Good Vibes Hospitality is het externe hoofdkantoor voor horecazaken die slimmer willen ondernemen en structureel beter willen presteren.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Wij ondersteunen horecaondernemers met een totaalpakket waarin cijfers, personeel, operatie en marketing continu samenwerken. Daardoor kunnen we snel schakelen, goed bijsturen en kansen direct omzetten in resultaat.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Ons doel is simpel: jouw horecazaak zo inrichten dat deze niet alleen vandaag goed draait, maar ook structureel meer omzet oplevert, beter georganiseerd is en meer overhoudt.
              </p>
            </div>
          </div>

          {}
          <div ref={rightColRef} className="relative flex justify-center lg:justify-end px-4 lg:px-0">
            <div className="relative z-10 rounded-lg shadow-xl overflow-hidden backdrop-blur-xl bg-white/30 border border-white/20 w-full max-w-md aspect-square">
              <img src="https://accurate-cicada.10web.cloud/wp-content/uploads/2026/05/The-Creators-Hub-Jordi-Sloots-Grandcafe-de-Lichttoren-09322-klein.jpg" data-wvc-srcset="https://accurate-cicada.10web.cloud/wp-content/uploads/2026/05/The-Creators-Hub-Jordi-Sloots-Grandcafe-de-Lichttoren-09322-klein.jpg-wvc-srcset" data-wvc-sizes="https://accurate-cicada.10web.cloud/wp-content/uploads/2026/05/The-Creators-Hub-Jordi-Sloots-Grandcafe-de-Lichttoren-09322-klein.jpg-wvc-sizes" alt="Modern architectural design approach" className="w-full h-full object-cover" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}